export const defaultSuppliersQueryParams = {
  page: 1,
  size: 20,
};
